import Popup from "reactjs-popup";

const popUpStyle = {
    contentStyle: {background: '#fffbfb', borderRadius: '10px'},
    overlayStyle: {background: 'rgba(223,229,229,0.29)', overflowY: 'auto'},
    arrowStyle: {color: '#000'}
}
export function BasePopup(props){
    const {children,open,onOpenChange}=props
    console.log(open);
    return <Popup onClose={() => onOpenChange(false)} open={open}
                  arrowStyle={popUpStyle.arrowStyle}
                  overlayStyle={popUpStyle.overlayStyle}
                  contentStyle={popUpStyle.contentStyle}
                  children={children}/>
}